// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4fe7b7b2","977":"45c25791"}[chunkId] + ".chunk.js";
};